import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import SelectionGroupItem from './SelectionGroupItem.js';

class SelectionGroup extends React.Component {
    render() {
        let { selectedItem  } = this.props;
        const { items  } = this.props;
        if (!selectedItem) {
            selectedItem = items[0].value;
        }
        return /*#__PURE__*/ React.createElement("div", {
            className: "selection-group"
        }, items.map((item)=>/*#__PURE__*/ React.createElement(SelectionGroupItem, swcHelpers.extends({}, item, {
                key: item.value,
                isChecked: item.value === selectedItem,
                handleChange: this.handleChange
            }))
        ));
    }
    constructor(...args){
        super(...args);
        this.state = {
            value: ''
        };
        this.handleChange = (event)=>{
            const value = event.currentTarget.value;
            this.setState({
                value
            });
            this.props.onChange && this.props.onChange(value);
        };
    }
}

export { SelectionGroup as default };
//# sourceMappingURL=SelectionGroup.js.map
